import type { C1_BaseObject } from "../model/C1_BaseObject";
import type C1_EloItem from "../model/C1_EloItem";
import type { C1_Furniture } from "../model/C1_Furniture";
import type { C1_Opening } from "../model/C1_Opening";
import { C1_EloItem_Type } from "../types/C1_EloTypes";

export const MOBILE_SELECTED_ELO_MOVE = "c1-mobile-selected-elo-move";
export type MobileMoveTarget =
  | { kind: "elo"; item: C1_EloItem; origin: {x: number; y: number} }
  | { kind: "furniture"; item: C1_Furniture; origin: {x: number; y: number} }
  | { kind: "opening"; item: C1_Opening; origin: {x: number; y: number} };
export type MobileEloMoveRequest = { itemId: string; phase: "start" | "move" | "end"; point: {x: number; y: number}; disableDocking: boolean };

/** Rooms, floors, connections and key channels never become movement targets. */
export function mobileSelectedMoveTarget(selection: C1_BaseObject<any> | undefined): MobileMoveTarget | undefined {
  if (!selection || selection.owner?.isDeleted) return;
  const lightGroup = selection.className === "C1_Consumer" ? (selection as import("../model/C1_Consumer").C1_Consumer).lightGroup : undefined;
  if (lightGroup) selection = lightGroup;
  if (selection.className === "C1_Furniture") {
    const item = selection as C1_Furniture;
    const origin = item.equipmentPostitionGeometric(item.id);
    if (origin && item.room) return {kind: "furniture", item, origin};
  } else if (selection.className === "C1_Opening") {
    const item = selection as C1_Opening;
    return {kind: "opening", item, origin: item.absolutePosition};
  } else if (["C1_EloItem", "C1_EloGroup", "C1_Button", "C1_Consumer"].includes(selection.className)) {
    let item = selection as C1_EloItem;
    const seen = new Set<C1_EloItem>();
    for (let ancestor: C1_EloItem | undefined = item; ancestor && !seen.has(ancestor); ancestor = ancestor.parent as C1_EloItem | undefined) {
      seen.add(ancestor);
      if (!["C1_EloItem", "C1_EloGroup", "C1_Button", "C1_Consumer"].includes(ancestor.className)) break;
      if (ancestor.className === "C1_EloGroup" && ancestor.definition?.toDefinition().type === C1_EloItem_Type.PlugGroup) {
        item = ancestor;
        break;
      }
    }
    const origin = item.displayPosition;
    if (origin) return {kind: "elo", item, origin};
  }
}

export function requestMobileEloMove(area: Element, request: MobileEloMoveRequest): boolean {
  const event = new CustomEvent(MOBILE_SELECTED_ELO_MOVE, {bubbles: true, cancelable: true, detail: request});
  area.dispatchEvent(event);
  return event.defaultPrevented;
}
